import React from "react";

import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useTableResponsive } from "../../../hooks/useTableResponsive";
import PdfZipItem from "../../../components/PdfZipItem";

const EquityTabComponent = ({ data, title }) => {
  const { getText } = useLanguageTranslation();
  useTableResponsive(data);
  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
          <div className="title-sec">
            <h2>{title}</h2>
          </div>
          <div className="table-responsive">
            <table className="table table-striped custom-table">
              <thead className="thead-dark">
                <tr>
                  <th>{getText("S.No.", "क्र. सं.")}</th>
                  <th>{getText("Title", "शीर्षक")}</th>
                  <th>{getText("Financial Year", "वित्तीय वर्ष")}</th>
                  <th>{getText("Open PDF", "पीडीएफ खोलें ")}</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td data-key={getText("S.No.", "क्र. सं.")}>
                        {index + 1}
                      </td>
                      <td data-key={getText("Title", "शीर्षक")}>
                        {item.title}
                      </td>
                      <td data-key={getText("Financial Year", "वित्तीय वर्ष")}>
                        {item.field_financial_year}
                      </td>
                      <td data-key={getText("Open PDF", "पीडीएफ खोलें ")}>
                        <PdfZipItem
                          filePath={item?.field_document_equity}
                          filesize={item?.filesize}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>No record Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default EquityTabComponent;
